import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { ArticleStatusReceivedModel } from './article-status-received-model';
import * as ngswal from "sweetalert";
declare var $;

@Component({
  selector: 'app-article-status-received',
  templateUrl: './article-status-received.component.html',
  styleUrls: ['./article-status-received.component.css']
})
/** article-status-received component*/
export class ArticleStatusReceivedComponent implements OnInit {
  modelItem = new ArticleStatusReceivedModel();

  @ViewChild('dataTable') table;
  public aMenuList = [];
  dataTable: any;
  dtOptions: any;
  dataSet: any;
  journalList: any;
  issueList: any;
  volumeList: any;

  ngOnInit() {
    ApiMethod.getBaseUrl();
  }

  /** articleStatus-report ctor */
  constructor(private router: Router, private http: HttpClient) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ArticleStatusReceivedModel>data["ArticleStatusReportPage"];

        $(".select2").select2();

        $("#lstJournals").select2({
          placeholder: "Select Journal", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstJournals").val([]).trigger("change");

        $("#lstVolume").select2({
          placeholder: "Select Volume", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstVolume").val([]).trigger("change");

        $("#lstIssue").select2({
          placeholder: "Select Issue", dropdownParent: "#divMainFilter",
          allowClear: true, tags: true
        });
        $("#lstIssue").val([]).trigger("change");

        this.getJournalsList();

        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
        this.getArticleStatusReportList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  getArticleStatusReportList() {
    $("#LoadingImage").show();

    var fromDate = $("#Txt_FromDate").val();//'01/01/2021';
    var toDate = $("#Txt_ToDate").val();

    var reportData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: fromDate.toString(),
      ToDate: toDate.toString(),
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text()
    };

    ApiMethod.postMethod(this.modelItem.ArticleStatusReportAPI, reportData).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = '';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'ArticleStatusReceivedReportModule';
        dataItem.isDefault = false;
        dataItem.ResponsiveMode = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        //let acolList = result.acolListL;
        //this.dataTable = customfunctions.dynamicDataTable(acolList, '', this.dataTable, this.dataSet, (GlobalConstants.size.height - 150), 'ArticleReportModule', '', false);
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  getFiltered() {
    this.getArticleStatusReportList();
  }

  resetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    $("#lstJournals").val(0).change();
    $("#lstVolume").val(0).change();
    $("#lstIssue").val(0).change();
    this.getArticleStatusReportList();
  }

  getJournalsList() {
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + '/' + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
}
